import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-semibold gold-text mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('footer_company')}
            </h3>
            <p className="text-[#A1A1AA] text-sm mb-6">
              {t('footer_tagline')}
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <MapPin className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-sm">Bahnhofstrasse 1, 8560 Marstetten</span>
              </div>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                <a href="tel:+41799270731" className="text-sm hover:text-[#D4AF37] transition-colors">
                  +41 79 927 07 31
                </a>
              </div>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                <a href="mailto:etourtransfer@gmail.com" className="text-sm hover:text-[#D4AF37] transition-colors">
                  etourtransfer@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3 text-[#A1A1AA]">
                <MessageCircle className="w-4 h-4 text-green-500" />
                <a 
                  href="https://wa.me/41799270731" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm hover:text-green-500 transition-colors"
                >
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('footer_quick_links')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('nav_home')}
                </Link>
              </li>
              <li>
                <Link to="/#services" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('nav_services')}
                </Link>
              </li>
              <li>
                <Link to="/#fleet" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('nav_fleet')}
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('nav_booking')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('nav_contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('footer_legal')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/impressum" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('footer_privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors">
                  {t('footer_terms')}
                </Link>
              </li>
              <li className="text-sm text-[#A1A1AA]">
                CHE-468.004.384
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-[#A1A1AA]">
            {t('footer_copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
